import React from 'react';
import { oneDecimal } from '../../helpers/formatters'
import styles from './region-entity-table.module.scss';
import { connect } from 'react-redux';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import {
    setActiveEntity,
    setComparedEntity,
    setActivePage,
} from '../../actions/ui';
import { RegionTableHeader } from "./region-table-header"
import {
    ArrowRight,
} from "../../components/icons";

const RegionTableComponent = ({
    region,
    setActiveEntity,
    setComparedEntity,
    setActivePage,
    isMobile,
}) => {

    return (
        <div style={{ width: '100%' }}>
            <div style={{ width: "100%", overflow: "auto" }}>
                <table className={styles.entityRegionTable}>
                    <tbody>
                        <RegionTableHeader region={region} comparing={false} isMobile={isMobile} />
                        {region.byRegionByEntity.map((e, i) => {
                            const hasCampuses = e.entityCategory === 'Universities' || e.entity.toLocaleLowerCase().includes("department of employment") || e.entity.includes("TAFE")
                            return (
                                <tr className={styles.regularTableRow} key={e + i}>
                                    {!isMobile &&
                                        <td className={styles.institutionType}>
                                            {/* Only show the category if it's the first instance in the table */}
                                            {region.byRegionByEntity
                                                .indexOf(region.byRegionByEntity.find(({ orderingCategory }) => orderingCategory === e.orderingCategory)) === i ? e.orderingCategory : ""}
                                        </td>
                                    }

                                    <td style={{ minWidth: 200 }}
                                        onClick={() => {
                                            setActiveEntity(e.entity);
                                            setComparedEntity(null);
                                            setActivePage('entity');
                                        }}
                                        data-clickable={true}
                                    >
                                        {e.entity}
                                    </td>
                                    <td className={styles.numberCell}>{hasCampuses ? e.numberOfCampuses.toLocaleString() : ""}</td>
                                    <td className={styles.numberCell}>{!hasCampuses ? e.numberOfCampuses.toLocaleString() : ""}</td>
                                    <td className={styles.numberCell}>{oneDecimal(e.numberOfStudents).toLocaleString()}</td>
                                    <td className={styles.numberCell}>{oneDecimal(e.numberOfEmployees).toLocaleString()}</td>
                                </tr>
                            )
                        })
                        }
                    </tbody>
                </table>
            </div>
            {isMobile &&
                <div style={{ textAlign: "left", marginTop: 20 }}>
                    <span className={styles.cellInfoText}>Scroll the table to see more</span>
                    <ArrowRight fill="blue" width="10px" height="10px" style={{ marginLeft: 10 }} />
                </div>
            }
        </div>
    )
}

const mapDispatchToProps = {
    setActiveEntity,
    setComparedEntity,
    setActivePage,
};

const mapStateToProps = (state, props) => ({
    isMobile: selectors.getIsMobile(state),
});

RegionTableComponent.propTypes = {
    region: PropTypes.object,
    setActiveEntity: PropTypes.func,
    setActivePage: PropTypes.func,
    setComparedEntity: PropTypes.func,
};

const RegionTable = connect(mapStateToProps, mapDispatchToProps)(RegionTableComponent);
export { RegionTable }


// WEBPACK FOOTER //
// ./src/components/region-entity-table/region-table.js